import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import debounce from "lodash.debounce";
import { PlaylistsPage } from "./PlaylistsPage";
import { PlaylistsSidebar } from "./components"
import { PlaylistPage } from "./PlaylistPage";
import { NavigationHelper } from "../helpers";
import { AccountWarnings } from "../components/AccountWarnings";

export const PlaylistsRouter: React.FC = () => {
  const location = useLocation();
  const [refreshKey, setRefreshKey] = React.useState("");

  React.useEffect(NavigationHelper.hideMobileSidebar, [location.pathname]) // eslint-disable-line

  const refreshSidebar = React.useMemo(() => debounce(() => {
      setRefreshKey(NavigationHelper.getRefreshKey());
    }, 300),[]);

  return (
    <div className="section-layout">
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <div className="sidebar-overlay" onClick={NavigationHelper.closeMobileSidebar}></div>
      <nav className="section-sidebar d-none d-md-block" id="sidebar">
        <button className="sidebar-close-btn" onClick={NavigationHelper.closeMobileSidebar} aria-label="Close sidebar">
          <i className="fas fa-times"></i>
        </button>
        <PlaylistsSidebar refreshKey={refreshKey} />
      </nav>
      <main className="section-content">
        <AccountWarnings />
        <Routes>
          <Route path="/:id" element={<PlaylistPage refreshSidebar={refreshSidebar} />} />
          <Route path="/" element={<PlaylistsPage />} />
        </Routes>
      </main>
    </div>
  );
};